module.exports = __webpack_public_path__ + "img/Icone_300.b0c0bc6a.svg";